import React from 'react';
import store from '@Store';

// Helper function to get the display name of a component
const getDisplayName = (WrappedComponent) => WrappedComponent.displayName || WrappedComponent.name || 'Component';

// Higher-order component to inject a reducer
export default function withReducer(key, reducer, injectImmediately = false) {
  let injected;

  if (injectImmediately) {
    injected = !!store.injectReducer(key, reducer);
  }

  return (Target) => {
    function Wrapper(props) {
      if (!injected) {
        store.injectReducer(key, reducer);
        injected = true;
      }

      return <Target {...props} />;
    }

    Wrapper.displayName = `withReducer("reducer:${key}", ${getDisplayName(Target)})`;

    return Wrapper;
  };
}
